const returnTheme = () => {
  const buttonColor = "rgb(0, 77, 53)";
  const buttonLightColor = "rgba(0, 77, 53, 0.12)";
  const buttonTextColor = "rgb(255, 255, 255)";
  return { buttonColor, buttonLightColor, buttonTextColor };
};

const theme = {
  dark: false,
  colors: {
    primary: "rgb(0, 77, 53)",
    lightPrimary: "rgb(0, 128, 89)",
    whiteText: "rgb(255, 255, 255)",
    blackText: "rgb(57,62,70)",
    black: "rgb(57,62,70)",
    white: "rgb(255,255,255)",
    blue54: "#070a54",
    lightGray: "rgb(241, 241, 241)",
    midGray: "rgb(221, 221, 221)",
    logoGray: "rgb(162, 162, 162)",
    bgFooter: "rgb(240, 242, 245)",
    lightBlue: "rgb(234, 239, 244)",
    buttonColor: returnTheme().buttonColor,
    buttonLightColor: returnTheme().buttonLightColor,
    buttonTextColor: returnTheme().buttonTextColor,
  },
};

export default theme;
